<template>
  <v-radio-group
      v-model="modelData"
      v-bind="$attrs"
      v-on="$listeners"
      dense
    >
      <v-radio
        v-for="(option, index) in options"
        :label="option[optionLabel]"
        :value="option[optionValue]"
        :class="option.class || ''"
        :key="index"
      ></v-radio>
  </v-radio-group>
</template>


<script>
export default {
  name: "SGPRadioGroupComponent",

  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },

    titulo: {
      type: String,
      required: true
    },

    optionLabel: {
      type: String,
      required: false,
      default: "label"
    },

    optionValue: {
      type: String,
      required: false,
      default: "value"
    },

    value: {
      required: true,
      default: false
    }
  },

  computed: {
    modelData: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      }
    },
  }
}
</script>